import { finite } from "@/lib/science/units";

type Field = "mass" | "conc" | "volume" | "mw";
export interface MassMolarityInput {
  mass: number | null;
  conc: number | null;
  volume: number | null;
  mw: number | null;
}

// mass = conc × volume × mw. Base units: mass g, conc mol/L, volume L, mw g/mol.
// Exactly one field must be null (the unknown to solve for).
export function solveMassMolarity(known: MassMolarityInput): number | null {
  const nulls = (["mass", "conc", "volume", "mw"] as Field[]).filter(
    (k) => known[k] === null,
  );
  if (nulls.length !== 1) return null;
  const vals = [known.mass, known.conc, known.volume, known.mw].filter(
    (n): n is number => n !== null,
  );
  if (!finite(...vals)) return null;

  const { mass, conc, volume, mw } = known;
  switch (nulls[0]) {
    case "mass":
      return conc! * volume! * mw!;
    case "conc":
      return volume! === 0 || mw! === 0 ? null : mass! / (volume! * mw!);
    case "volume":
      return conc! === 0 || mw! === 0 ? null : mass! / (conc! * mw!);
    case "mw":
      return conc! === 0 || volume! === 0 ? null : mass! / (conc! * volume!);
    default:
      return null;
  }
}
